import fetch from 'isomorphic-fetch';
import { config } from '../config';

// Cache the result
let userHasIpAccess = null;

export default async function hasIpAccess() {
    const { accessEndpoint } = config.pluss;

    // If result is cached, return the result
    if (userHasIpAccess !== null) {
        return userHasIpAccess;
    }

    try {
        const endpointResponse = await fetch(accessEndpoint);
        userHasIpAccess = endpointResponse.status === 200;

        return userHasIpAccess;
    } catch (err) {
        return false;
    }
}



/** WEBPACK FOOTER **
 ** ./src/utils/plussIpAccess.js
 **/